import AttendeeDetailsStep from './AttendeeDetailsStep';
import InterestStep from './Interest';
import PaymentStep from './PaymentStep';
import TicketTypeStep from './TicketTypeStep';

export interface AttendeeDetailsStepData {
  firstName: string;
  lastName: string;
  email: string;
  jobTitle: string;
  company: string;
  jobRole: string;
  phoneNumber: string;
  zipCode: string;
}

interface TicketTypeStepData {
  ticketTypeId: string;
}

interface InterestStepData {
  name: string;
}

interface PaymentStepData {
  initiated: boolean;
  completed: boolean;
}

export type StepDataMap = {
  attendeeDetailsStep: AttendeeDetailsStepData;
  ticketTypeStep: TicketTypeStepData;
  interestStep: InterestStepData;
  paymentStep: PaymentStepData;
};

export interface StepProps {}

interface Step {
  component: React.ComponentType<StepProps>;
  key: keyof StepDataMap;
}

const steps: Step[] = [
  { component: AttendeeDetailsStep, key: 'attendeeDetailsStep' },
  { component: TicketTypeStep, key: 'ticketTypeStep' },
  { component: InterestStep, key: 'interestStep' },
  { component: PaymentStep, key: 'paymentStep' },
];

export const stepComponents = steps.reduce((acc, step) => {
  acc[step.key] = step.component;
  return acc;
}, {} as { [key in keyof StepDataMap]: React.ComponentType<StepProps> });

export default steps;
